import Resource from './Resource';

export default class ScheduleWindow extends Resource {
	constructor(options={}) {
		let {
			route = 'interactive-schedules/schedule-window',
			query = {},
			data = {}
		} = options;

		let config = {
			route: route,
			query: query,
			data: data
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	put() {
		return this.request('put');
	}

	post() {
		return this.request('post');
	}
}
